import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, contains } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectedEntregaRealizadaZE } from "./types";

/**Determina si una EntregaZERealizada esta seleccionada */
function estaSeleccionada(item: models.EntregaZERealizadaDTO, selected: number[]): boolean {
    return contains(selected, item.IdRegistro);
}

/**Obtiene un conjunto de EntregaZERealizada a un conjunto de SelectedEntregaRealizadaZE */
export function toSelected(items: models.EntregaZERealizadaDTO[], selected: number[]): SelectedEntregaRealizadaZE[] {
    const ret = items.map(x => ({ ...x, Selected: estaSeleccionada(x, selected) }));
    return ret;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/multientregas/logic.ts